module.exports = __webpack_public_path__ + "static/media/laptop.358d9036.svg";